import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import marked from "marked";

import MarkdownRenderer from '../../components/MarkdownRenderer';

class Markdown extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            markdown: ''
        }

        this.props.includeNav();
    }

    componentWillMount() {
        const markdownPath = require("./test.md");
        
        fetch(markdownPath)
            .then(response => {
                return response.text()
            })
            .then(text => {
                this.setState({
                    markdown: marked(text)
                })
            })
    }

    render() {

        return (
            <DocumentTitle
                title={'BCS Documentation - Markdown'}>
                <section className="page" data-component="markdown">
                    <div className="row">
                        <div className="col-xs-12 col-gutter-lr border-bottom">
                            <h1>Markdown</h1>
                        </div>
                        <div className="col-xs-12">
                            <div className="card">
                                <MarkdownRenderer text={this.state.markdown}/>
                            </div>
                        </div>
                    </div>
                </section>
            </DocumentTitle>
        )
    }
}

export default Markdown;



// WEBPACK FOOTER //
// ./src/pages/Markdown/index.js